import { orderBy } from 'lodash';

import { Action } from '../../actions';
import {
    CHANGE_MARKETERS_FILTER_PARAMS,
    CHANGE_MARKETERS_PAGE_STATUS,
    FETCH_MARKETERS_DATA,
    FILTER_MARKETERS,
    SORT_MARKETERS,
    UPDATE_MARKETERS_DATA
} from '../../actions/marketers/marketersList';
import { MarketersListCellItem } from '../../declarations/marketersList/marketersList';
import { routeMarketersToKeyMap } from '../../service/MarketersHelper';
import {
    Marketer,
    Marketers,
    MarketersPageStates
} from '../../typings/marketers';

export const marketersInitialState: Marketers = {
    marketers: [],
    pageStatus: MarketersPageStates.PENDING,
    allMarketers: [],
    filter: {
        product: ''
    }
};

export function marketersList(
    state: Marketers = marketersInitialState,
    action: Action
): Marketers {
    switch (action.type) {
        case FETCH_MARKETERS_DATA:
            return {
                ...state,
                pageStatus: MarketersPageStates.LOADING
            };

        case UPDATE_MARKETERS_DATA: {
            const marketers = action.sortParams
                ? orderBy<MarketersListCellItem>(
                      action.marketers,
                      [routeMarketersToKeyMap[action.sortParams.key]],
                      [action.sortParams.direction]
                  )
                : action.marketers;

            return {
                ...state,
                allMarketers: marketers,
                marketers
            };
        }

        case FILTER_MARKETERS: {
            const marketers = state.allMarketers;

            return {
                ...state,
                marketers: marketers.filter((item: Marketer) => {
                    if (!state.filter.product) {
                        return true;
                    }

                    return item.ownProducts.some(product => {
                        let PRODUCT = true,
                            ACCESS = true;

                        if (state.filter.product) {
                            PRODUCT =
                                product.productName === state.filter.product;

                            if (
                                state.filter.access &&
                                state.filter.access.length
                            ) {
                                ACCESS =
                                    product.access === state.filter.access[0];
                            }
                        }

                        return PRODUCT && ACCESS;
                    });
                })
            };
        }

        case CHANGE_MARKETERS_PAGE_STATUS:
            return {
                ...state,
                pageStatus: action.status
            };

        case CHANGE_MARKETERS_FILTER_PARAMS:
            return {
                ...state,
                filter: { ...action.params }
            };

        case SORT_MARKETERS:
            return {
                ...state,
                marketers: orderBy<MarketersListCellItem>(
                    [...state.marketers],
                    [routeMarketersToKeyMap[action.sortParams.key]],
                    [action.sortParams.direction]
                )
            };

        default:
            return state;
    }
}
